import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { changeForm } from "../searchFlightsSlice";

interface Props {
  format: "single" | "multi";
}
function NonStopFlightsInput({ format }: Props) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const nonStopFlights = useAppSelector(
    (state) => state.searchFlights.form.nonStopFlights
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const onChange = () =>
    dispatch(changeForm({ nonStopFlights: !nonStopFlights }));

  if (format === "single") {
    return (
      <div className="field">
        <div className="control">
          <label
            className="checkbox"
            title={t("CHECKBOX_TITLE_NON_STOP_FLIGHTS")}
          >
            <input
              type="checkbox"
              checked={nonStopFlights}
              disabled={disabled}
              onChange={onChange}
            />
            {t("CHECKBOX_NONSTOP_FLIGHTS")}
          </label>
        </div>
      </div>
    );
  } else {
    return (
      <div className="field">
        <div className="control">
          <label className="radio">
            <input
              type="radio"
              name="nonStopFlights"
              checked={nonStopFlights === true}
              onChange={onChange}
            />
            &nbsp;{t("CHECKBOX_NONSTOP_FLIGHTS")}
          </label>
          <label className="radio">
            <input
              type="radio"
              name="nonStopFlights"
              checked={nonStopFlights === false}
              onChange={onChange}
            />
            &nbsp;{t("ALL")}
          </label>
        </div>
      </div>
    );
  }
}

export default NonStopFlightsInput;
